/* Lo que la pantalla «Catálogo» decide sin pintar nada · CATÁLOGO VIVO F1.
   Funciones puras, para probarlas sin montar la pantalla. */

// Los tipos de dato, con el nombre que entiende alguien sin capacitación.
// `unidad`: pide unidad; `opciones`: pide la lista de opciones.
export const TIPOS_DE_DATO = [
  { id: 'TEXTO', nombre: 'Texto' },
  { id: 'NUMERO', nombre: 'Número con unidad (10 kΩ, 12 mm)', unidad: true },
  { id: 'ENTERO', nombre: 'Número entero (páginas, piezas)' },
  { id: 'BOOLEANO', nombre: 'Sí o no' },
  { id: 'LISTA', nombre: 'Una opción de una lista', opciones: true },
  { id: 'LISTA_MULTIPLE', nombre: 'Varias opciones de una lista', opciones: true },
  { id: 'FECHA', nombre: 'Fecha' },
  { id: 'REFERENCIA', nombre: 'Otro producto del inventario' },
];

const normal = (t) => (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ').trim().toLowerCase();

// La categoría que ya se llama así en la empresa (R-CV8: el nombre es único
// en toda la empresa, sin distinguir mayúsculas). El servidor compara con
// `upper(trim())`, que sí distingue acentos; aquí se avisa también sin ellos
// porque «Electronica» y «Electrónica» son la misma para quien escribe.
export function mismoNombre(categorias, nombre) {
  const n = normal(nombre);
  if (!n) return null;
  return (categorias || []).find((c) => normal(c.nombre) === n) || null;
}

// Ella y todas las que tiene dentro: no pueden ser su madre (sería un ciclo).
export function descendientes(categorias, id) {
  const fuera = new Set([id]);
  for (const c of categorias || []) {
    if ((c.ruta || '').includes(`/${id}/`)) fuera.add(c.id);
  }
  return fuera;
}
